import { c as _c } from "react/compiler-runtime";
import type { TouchDesignDataPoint, TouchDesignSerie } from '../interfaces';
import { curveSmootherRequirementsSymbol, type CurveSmootherRequirements } from '@/lib/geometry/curve-smoother/curve-smoother.requirements';
import type { CurveSmootherLoessOptions } from '@/lib/geometry/curve-smoother/curve-smoother-loess';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
import { useNamedInjection } from '@/hooks/use-named-injection';
import { useCallback } from 'react';
export const useSmoothedSerieLoess = t0 => {
  const $ = _c(7);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      bandwidthFraction: 1
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const loessSmoother = useNamedInjection(curveSmootherRequirementsSymbol, SmoothStrategy.Loess);
  let t2;
  if ($[2] !== loessSmoother || $[3] !== options) {
    t2 = inputSerie => {
      const inputData = inputSerie.data.map(_temp);
      const smoothedData = loessSmoother.smoothCurve(inputData, options);
      const outputData = inputSerie.data.map((dataPoint_0, index) => ({
        ...dataPoint_0,
        payload: smoothedData[index]
      }));
      return {
        ...inputSerie,
        data: outputData
      };
    };
    $[2] = loessSmoother;
    $[3] = options;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const smoothLoess = t2;
  let t3;
  if ($[5] !== smoothLoess) {
    t3 = {
      smoothLoess
    };
    $[5] = smoothLoess;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(dataPoint) {
  return dataPoint.payload;
}